<template>
  <div class="success-container">
    <h2>¡Pago Exitoso! 🎉</h2>
    <p>Gracias por tu compra. Serás redirigido al inicio en unos segundos...</p>
    <button @click="goHome">Ir al Inicio</button>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { createCartStore } from '@/stores/cart'; // ajusta la ruta según tu proyecto

const cartStore = createCartStore();

export default {
  name: "SuccessView",
  methods: {
    goHome() {
      cartStore.resetState();  // Usas resetState aquí
      this.$router.push('/pedidos');
    }
  },
mounted() {
  Swal.fire({
    title: "¡Pedido registrado! 🎉",
    text: "Tu pedido ha sido registrado con éxito. Mañana te llegará tu pedido. Si solicitaste factura, te llegará al correo registrado.",
    icon: "success",
    confirmButtonColor: '#228b22',
    confirmButtonText: "OK",
    timer: 3000,
    timerProgressBar: true
  }).then(() => {
    cartStore.resetState();

    // 👉 Esto evita volver a esta vista al presionar atrás
    this.$router.replace("/pedidos");
  });
}

};
</script>

<style scoped>
.success-container {
  text-align: center;
  padding: 20px;
}
button {
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  margin-top: 10px;
}
button:hover {
  background-color: #45a049;
}
</style>
